import React, { Component } from 'react';
import { logout, logoutAndNavigateToRoot } from '../../auth/actions/authActions';
import { connect } from 'react-redux';
import Menu from './menu';
import { action as toggleMenu } from 'redux-burger-menu';
import { PORTAL_FEATURE } from '../constants/coreConstants';
import { browserHistory } from 'react-router';
import { clearSelectedMerchant } from '../../auth/actions/authActions';

class LeftMenu extends Component {
    constructor(props) {
        super(props);
        this.navigateTo = this.navigateTo.bind(this);
    }

    navigateTo(location, event) {
        event.preventDefault();
        browserHistory.push(location);
        this.props.closeMenu();
    }

    render() {
        let hrefText = "tel:".concat(this.props.core.serviceDeskContactNumber);
        
        return (
            <div>
                {this.props.core.merchantInfo ? (
                    <Menu className={this.props.className}>
                        {this.props.core.features[PORTAL_FEATURE] ? (
                            <div>
                                <div className="user row m-t-10 m-b-10">
                                    <div className="col-xs-1">
                                        <i className="fa fa-user-circle-o" />
                                    </div>
                                    <div className="col-xs-10 p-r-0">
                                        <strong>{this.props.core.merchantInfo.name}</strong>
                                    </div>
                                    {this.props.auth.multiMerchant ? (
                                        <div className="col-xs-12 m-t-10">
                                            <div className="row f-s-14">
                                                <div className="col-xs-1">
                                                    <i className="fa fa-users" />
                                                </div>
                                                <div className="col-xs-10 p-r-0">
                                                    <span onClick={this.props.clearSelectedMerchant}>Switch Merchant</span>
                                                </div>
                                            </div>
                                        </div>
                                    ) : null}
                                </div>

                                <nav className="bm-item-list" data-radium="true" style={{ height: "100%" }}>
                                    <a href="#" onClick={this.navigateTo.bind(this, '/')} data-radium="true">
                                        <i className="fa fa-fw fa-home" /><span>Home</span>
                                    </a>
                                    <a href="#" onClick={this.navigateTo.bind(this, '/jobs')} data-radium="true" >
                                        <i className="fa fa-fw fa-check-square-o" /><span>Jobs</span>
                                    </a>
                                    <a href="#" onClick={this.navigateTo.bind(this, '/terminals')} data-radium="true" >
                                        <i className="fa fa-fw fa-credit-card" /><span>Terminals</span>
                                    </a>
                                    <a href="#" onClick={this.navigateTo.bind(this, '/profile')} data-radium="true" >
                                        <i className="fa fa-fw fa-user" /><span>My Profile</span>
                                    </a>
                                    <a href="#" onClick={this.props.logout} data-radium="true">
                                        <i className="fa fa-fw fa-sign-out" /><span>Logout</span>
                                    </a>
                                </nav>
                            </div>
                        ) : this.props.booking.details.jobId ? (
                            <div>
                                <h3>My Details</h3>
                                <p>
                                    <i className="fa fa-user" /> <strong>{this.props.booking.details.contact}</strong><br />
                                    <i className="fa fa-phone" /> {this.props.booking.details.phoneNumber}
                                </p>
                                <h4>Address</h4>
                                <address>
                                    <i className="fa fa-map-marker" /> <strong>{this.props.booking.details.name}</strong><br />
                                    {this.props.booking.details.address}<br />
                                    {(this.props.booking.details.address2 || "").trim() ? (
                                        <span>{this.props.booking.details.address2}<br /></span>
                                    ) : null}
                                    {this.props.booking.details.city}, {this.props.booking.details.state}, {this.props.booking.details.postcode}
                                </address>
                            </div>
                        ) : null}

                        <div className="bm-contact text-center">
                            {this.props.core.features[PORTAL_FEATURE] ? (
                                <a href="#" data-radium="true" className="bm-link" onClick={this.props.logoutAndGoToRoot}>
                                    <i className="fa fa-fw fa-refresh" /><span>Log in to a different client</span>
                                </a>
                            ) : null}

                            <h3>Need Help?</h3>
                            <p>
                                <a className="btn btn-client btn-lg" href={hrefText} role="button">
                                    <i className="fa fa-phone m-r-5" /> {this.props.core.serviceDeskContactNumber}
                                </a>
                            </p>
                        </div>

                    </Menu>
                ) : null}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        core: state.core,
        auth: state.auth,
        uiState: state.core.uiState,
        booking: state.booking
    };
}

function mapDispatchToProps(dispatch) {
    return ({
        closeMenu: () => {
            dispatch(toggleMenu(false));
        },
        logout: () => {
            dispatch(toggleMenu(false));
            dispatch(logout());
        },
        logoutAndGoToRoot: () => {
            dispatch(logoutAndNavigateToRoot());
        },
        clearSelectedMerchant: () => {
            dispatch(clearSelectedMerchant());
            dispatch(toggleMenu(false));
        }
    });
}

export default connect(mapStateToProps, mapDispatchToProps)(LeftMenu);


// WEBPACK FOOTER //
// ./app/core/components/leftNav.js